export default __webpack_public_path__ + "static/media/wind-green.ad1e2513.svg";